import { type ChartData } from './chartConfigUtils';
import StandardChart from './StandardChart';

interface PaidCommissionCountChartProps {
    readonly data: readonly ChartData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
}
function PaidCommissionCountChart({
    data,
    loading = false,
    referenceValue,
}: PaidCommissionCountChartProps): JSX.Element {
    return (
        <StandardChart
            data={data}
            loading={loading}
            referenceValue={referenceValue}
            config={{
                chartType: 'column',
                yAxisTitleKey: 'statistics.charts.paidCommissionCount',
                yAxisTitleFallback: 'Paid Interest Count',
                yAxisColor: '#fa8c16',
                seriesNameKey: 'statistics.charts.paidCommissionCount',
                seriesNameFallback: 'Paid Interest Count',
                seriesColor: '#fa8c16',
            }}
        />
    );
}

export default PaidCommissionCountChart;
